import { render, staticRenderFns } from "./TheVerticalNavigation.vue?vue&type=template&id=08dde7c7&scoped=true&"
import script from "./TheVerticalNavigation.vue?vue&type=script&lang=js&"
export * from "./TheVerticalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TheVerticalNavigation.vue?vue&type=style&index=0&id=08dde7c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dde7c7",
  null
  
)

export default component.exports